import React, { useState, useEffect } from "react";
import {
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
} from "react-native";

import APP_CONFIG from "../../../../config/AppConfig";

import SelectedTag from "./SelectedTag";
import ImageComponent from "../../common/ImageComponent";
import Collapsible from "../../common/Collapsible/Collapsible";

export default function ActivityAssociatedTags(props) {
  const { tags, isCollapsed = false, title } = props;

  const [tagsList, setTagsList] = useState([]);

  useEffect(() => {
    setTagsList(tags);
  }, [tags]);

  return (
    <Collapsible isCollapsed={isCollapsed}>
      <View style={styles.scrollableContainer}>
        <View style={styles.listContainer}>
          {tagsList.map((tag, index) => (
            <View style={styles.chipContainer} key={index}>
              {tag.isSelected ? (
                <SelectedTag tag={tag} styles={styles}></SelectedTag>
              ) : (
                <TouchableOpacity style={styles.chip}>
                  {tag.icon ? (
                    <ImageComponent styles={styles.chipLogo} icon={tag.icon} />
                  ) : null}
                  <Text style={styles.chipText}>{tag.name}</Text>
                </TouchableOpacity>
              )}
            </View>
          ))}
        </View>
      </View>
    </Collapsible>
  );
}

const styles = StyleSheet.create({
  scrollableContainer: Platform.select({
    web: {
      overflowX: "auto",
    },
  }),
  listContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    width: "auto",
    height: "auto",
    paddingHorizontal: 20,
    backgroundColor: "#FFF",
  },
  chipContainer: {
    height: 38,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 6,
    marginRight: 4,
  },
  chip: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "100%",
    width: "100%",
    backgroundColor: "#F1FFFA",
    borderColor: "#E6F9F3",
    borderWidth: 1,
    borderRadius: 100,
    marginHorizontal: 4,
    paddingVertical: 7,
    paddingHorizontal: 10,
  },
  chipText: {
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }),
    fontWeight: "500",
    fontSize: 14,
    lineHeight: 17,
    color: APP_CONFIG.DEFAULT_COLOR,
    marginLeft: 5,
  },
  chipLogo: {
    width: 15,
    height: 15,
  },
  selectedChip: {
    backgroundColor: "#98d4b6",
    borderColor: "#98d4b6",
  },
  selectedChipText: {
    color: "#FFF",
  },
});
